import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const cases = [
  {
    icon: 'ri-user-unfollow-line',
    title: 'Posesión efectiva sin testamento',
    desc: 'Cuando el fallecido no dejó testamento, el trámite se realiza ante el Registro Civil. Determinamos herederos y gestionamos todo el proceso.',
    tag: 'Más común',
    tagColor: 'bg-primary-yellow text-black',
  },
  {
    icon: 'ri-file-text-line',
    title: 'Posesión efectiva con testamento',
    desc: 'Cuando existe testamento, el proceso se tramita ante un tribunal civil. Nos encargamos de cada gestión legal requerida.',
    tag: 'Judicial',
    tagColor: 'bg-black text-white',
  },
  {
    icon: 'ri-exchange-funds-line',
    title: 'Cesión de derechos hereditarios',
    desc: 'Si un heredero desea ceder su parte a otro, gestionamos los documentos necesarios para formalizar legalmente la cesión.',
    tag: 'Transferencia',
    tagColor: 'bg-gray-100 text-black',
  },
  {
    icon: 'ri-scales-3-line',
    title: 'Juicio de partición',
    desc: 'Cuando los herederos no llegan a acuerdo sobre la distribución de bienes, coordinamos el proceso judicial de partición.',
    tag: 'Conflicto',
    tagColor: 'bg-gray-100 text-black',
  },
];

const PosesionCases = () => {
  const scrollToForm = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const el = document.getElementById('posesion-efectiva-form');
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <span className="inline-block bg-black text-primary-yellow text-xs font-black uppercase tracking-widest px-4 py-1.5 rounded-full mb-4">
            Casos que atendemos
          </span>
          <h2 className="text-4xl lg:text-5xl font-extrabold text-black mb-4">
            ¿Cuál es tu situación?
          </h2>
          <p className="text-gray-500 text-lg max-w-xl mx-auto">
            Trabajamos en todos los escenarios posibles de herencia y sucesión en Chile.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6">
          {cases.map((item, idx) => (
            <motion.div
              key={idx}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: idx * 0.1, duration: 0.5 }}
              className="bg-white rounded-2xl p-8 border border-gray-100 flex flex-col gap-4"
            >
              <div className="flex items-start justify-between gap-4">
                <div className="w-14 h-14 flex items-center justify-center bg-black rounded-xl flex-shrink-0">
                  <i className={`${item.icon} text-primary-yellow text-2xl`}></i>
                </div>
                <span className={`text-xs font-bold uppercase tracking-widest px-3 py-1 rounded-full whitespace-nowrap self-start ${item.tagColor}`}>
                  {item.tag}
                </span>
              </div>
              <div>
                <h3 className="text-lg font-bold text-black mb-2">{item.title}</h3>
                <p className="text-gray-500 text-sm leading-relaxed">{item.desc}</p>
              </div>
              <a
                href="#posesion-efectiva-form"
                onClick={scrollToForm}
                className="inline-flex items-center gap-1.5 text-sm font-bold text-black hover:text-primary-yellow transition-colors duration-200 mt-auto cursor-pointer"
              >
                Consultar este caso
                <i className="ri-arrow-right-line text-base"></i>
              </a>
            </motion.div>
          ))}
        </div>

        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.4, duration: 0.5 }}
          className="text-center text-gray-400 text-sm mt-8"
        >
          ¿No estás seguro de qué tipo de trámite necesitas?{' '}
          <a
            href="#posesion-efectiva-form"
            onClick={scrollToForm}
            className="text-black font-semibold underline underline-offset-2 cursor-pointer hover:text-primary-yellow transition-colors"
          >
            Cuéntanos tu caso
          </a>{' '}
          y te orientamos sin costo.
        </motion.p>
      </div>
    </section>
  );
};

export default PosesionCases;
